type File = {
  url: string
}

export type Department = {
  id: number;
  title: string;
  isProduction: boolean;
};

export type MaturityLevel = 'Все' | 'I' | 'II' | 'III' | 'IV';

export type AdditionalInformation = {
  title: string;
  text?: string;
  links?: string[];
  files?: string[];
};

export type Requirement = {
  title: string;
  requirementID: string;
  groupRequirementID: string;
  groupRequirementFileRef: string;
  processID?: string;
  indicator: string;
  maturityLevel: MaturityLevel;
  answers: AnswerQuestion[];
  answersFactory?: AnswerQuestionFactory[];
  information?: AdditionalInformation;
  connectionColumns?: AdditionalInformation;
};

export type AnswerOption = 'Да' | 'Нет' | 'N/A';

export type AnswerQuestion = {
  answerId: number | null;
  department: string;
  departmentId: number;
  answer: AnswerOption;
  isEdit: boolean;
  actions?: string[];
  noRender: boolean;
  isAudit?: boolean;
};

export type AnswerQuestionFactory = {
  title: string;
  answersFactory: AnswerQuestion[];
};

export type GroupProcess = {
  title: string;
  requirements: Requirement[];
  information?: AdditionalInformation;
};

export type GroupRequirement = {
  title: string;
  groupRequirements: GroupProcess[];
};

export type RequirementColumn = {
  title: string;
  factory?: number;
  year?: number;
  month?: number;
  completedAssessment?: string;
  completionDate?: string;
  columnRequirements: GroupRequirement[];
};

export type RequirementFactory = {
  id: number;
  title: string;
  shortTitle: string;
  factoryRequirements: RequirementColumn[];
};

export type Action = {
  id: number;
  value: number;
};

export type ChartColumn = {
  id: number;
  value: number | 'N/A';
};

export type DataValue = {
  id: number;
  value: number;
}

export type Month = 'Январь' | 'Февраль' | 'Март' | 'Апрель' | 'Май' | 'Июнь' | 'Июль' |
 'Август' | 'Сентябрь' | 'Октябрь' | 'Ноябрь' | 'Декабрь';

 export enum MonthDictionary {
  Январь = 1,
  Февраль,
  Март,
  Апрель,
  Май,
  Июнь,
  Июль,
  Август,
  Сентябрь,
  Октябрь,
  Ноябрь,
  Декабрь
}

export type StatusQuestionnaire = 'Не начато' | 'В процессе' | 'Завершено';

export type AnswerContext = {
  factory: number;
  year: number;
  month: number;
  group?: number;
  column?: number;
  isEditNA: boolean;
}

export type Settings = {
  UsersGroup: unknown;
  id: number;
  title: string;
  description: string;
  url: string;
  icon: File;
}
